<template>
  <div class="badge" :class="`-${variant}`">{{ text }}</div>
</template>

<script>
const types = {
  D: {
    variant: 'danger',
    text: 'Débito',
  },
  E: {
    variant: 'info',
    text: 'Estorno',
  },
  C: {
    variant: 'success',
    text: 'Crédito',
  },
};

export default {
  name: 'UseTypeBadge',

  props: {
    type: {
      required: true,
      type: String,
    },
  },

  computed: {
    variant() {
      return types[this.type] ? types[this.type].variant : this.type;
    },

    text() {
      return types[this.type] ? types[this.type].text : this.type;
    },
  },
};
</script>

<style scoped>

</style>
